import { formatAmount, formatDate } from '../lib/format';
import type { Entry } from '../lib/types';

interface Props {
  entry: Entry;
  onTap?: (e: Entry) => void;
}

const ICONS: Record<Entry['kind'], string> = {
  income: '＋',
  expense: '−',
  exchange: '⇄',
};

export default function EntryRow({ entry, onTap }: Props) {
  const amount = Number(entry.amount);
  const cls = amount >= 0 ? 'amount-pos' : 'amount-neg';
  const title =
    entry.kind === 'income'   ? 'Income' :
    entry.kind === 'expense'  ? (entry.category || 'Expense') :
                                'Exchange';
  return (
    <div
      className="entry-row"
      onClick={onTap ? () => onTap(entry) : undefined}
      style={{ cursor: onTap ? 'pointer' : 'default' }}
    >
      <div className={`entry-badge ${entry.kind}`}>{ICONS[entry.kind]}</div>
      <div className="entry-main">
        <div className="entry-title">{title}{entry.photo_url ? ' 📎' : ''}</div>
        {entry.note && <div className="muted small ellipsis">{entry.note}</div>}
        <div className="muted small">{formatDate(entry.occurred_at)}</div>
      </div>
      <div className={`entry-amount ${cls}`}>
        {formatAmount(amount, entry.currency)}
      </div>
    </div>
  );
}
